<template>
  <div class="container advancedSettings">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ device.data.name }}
    </h1>

    <div class="buttons is-pulled-right">
      <a class="button is-success" @click="save">{{ $t("buttons.save") }}</a>
      <a class="button is-success" @click="setBalancedMode">
        {{ $t("settings.balancedMode") }}
      </a>
      <button
        v-if="device.data.type !== constants.deviceTypes.therm"
        class="button is-success"
        :disabled="!canEnterUserMode"
        @click="
          $router.push(
            '/installations/' +
              installation['.key'] +
              '/zone/' +
              zone.path.split('/')[zone.path.split('/').length - 1] +
              '/device/' +
              device.serialnumber +
              '/usermode'
          )
        "
      >
        {{ $t("settings.userMode") }}
      </button>
    </div>

    <h2 class="subtitle">{{ $t("settings.advancedSettingsDevice") }}</h2>
    <br />

    <div class="columns" style="width: 100%">
      <div class="column is-half">
        <div class="field">
          <b-switch v-model="form.block_local" type="is-success">
            {{ $t("settings.deviceLock") }}
          </b-switch>
        </div>
        <div
          class="field"
          v-if="device.data.type !== constants.deviceTypes.therm"
        >
          <b-switch v-model="form.hilo_pilot" type="is-success">
            {{ $t("settings.hiloPilot") }}
          </b-switch>
        </div>
        <div
          class="field"
          v-if="device.data.type !== constants.deviceTypes.oval_towel"
        >
          <b-switch v-model="form.hotel_mode" type="is-success">
            {{ $t("settings.hotelMode") }}
          </b-switch>
        </div>
        <div
          v-if="device.data.type === constants.deviceTypes.oval_towel"
          class="field"
        >
          <b-switch v-model="form.buzzer" type="is-success">
            {{ $t("settings.buzzer") }}
          </b-switch>
        </div>

        <div class="field">
          <label>{{ $t("settings.ecoTemp") }} {{ form.eco }} º</label>
          <range-input
            :min="ranges.eco.min"
            :max="ranges.eco.max"
            v-model="form.eco"
          >
            <template slot="start">
              <span class="rangeMin">{{ ranges.eco.min }} º</span>
            </template>
            <template slot="end">
              <span class="rangeMax">{{ ranges.eco.max }} º</span>
            </template>
          </range-input>
        </div>

        <div
          v-if="device.data.type === constants.deviceTypes.oval_towel"
          class="field"
        >
          <label
            >{{ $t("settings.offsetTemp") }} {{ form.offset_probe }} º</label
          >
          <range-input
            :min="ranges.offset_probe.min"
            :max="ranges.offset_probe.max"
            v-model="form.offset_probe"
          >
            <template slot="start">
              <span class="rangeMin">{{ ranges.offset_probe.min }} º</span>
            </template>
            <template slot="end">
              <span class="rangeMax">{{ ranges.offset_probe.max }} º</span>
            </template>
          </range-input>
        </div>

        <!--        <div class="field" v-if="device.data.backlight !== undefined">-->
        <!--          <label>{{ $t("settings.backlight") }} {{ form.backlight }}</label>-->
        <!--          <range-input-->
        <!--            :min="constants.ranges.backlight.min"-->
        <!--            :max="constants.ranges.backlight.max"-->
        <!--            v-model="form.backlight"-->
        <!--          >-->
        <!--            <template slot="start">-->
        <!--              <span class="rangeMin">-->
        <!--                {{ constants.ranges.backlight.min }}-->
        <!--              </span>-->
        <!--            </template>-->
        <!--            <template slot="end">-->
        <!--              <span class="rangeMax">-->
        <!--                {{ constants.ranges.backlight.max }}-->
        <!--              </span>-->
        <!--            </template>-->
        <!--          </range-input>-->
        <!--        </div>-->
      </div>
      <div class="column is-half">
        <div class="field">
          <b-switch v-model="form.ice_mode" type="is-success">
            {{ $t("settings.iceMode") }}
          </b-switch>
        </div>
        <div class="field">
          <b-switch v-model="form.block_remote" type="is-success"
            >{{ $t("settings.remoteLock") }}
          </b-switch>
        </div>
        <div
          class="field"
          v-if="
            device.data.adelanto_enable !== undefined &&
            device.data.type !== constants.deviceTypes.acs &&
            device.data.type !== constants.deviceTypes.towel
          "
        >
          <b-switch v-model="form.adelanto_enable" type="is-success">
            {{ $t("settings.adelantoMode") }}
          </b-switch>
        </div>
        <div class="field">
          <label>{{ $t("settings.comfortTemp") }} {{ form.comfort }}</label>
          <range-input
            :min="ranges.comfort.min"
            :max="ranges.comfort.max"
            v-model="form.comfort"
          >
            <template slot="start">
              <span class="rangeMin">{{ ranges.comfort.min }} º</span>
            </template>
            <template slot="end">
              <span class="rangeMax">{{ ranges.comfort.max }} º</span>
            </template>
          </range-input>
        </div>
        <!--        <div class="field" v-if="device.data.backlight !== undefined">-->
        <!--          <label-->
        <!--            >{{ $t("settings.backlightOn") }} {{ form.backlight_on }}</label-->
        <!--          >-->
        <!--          <range-input-->
        <!--            :min="constants.ranges.backlight.min"-->
        <!--            :max="constants.ranges.backlight.max"-->
        <!--            v-model="form.backlight_on"-->
        <!--          >-->
        <!--            <template slot="start">-->
        <!--              <span class="rangeMin">-->
        <!--                {{ constants.ranges.backlight.min }}-->
        <!--              </span>-->
        <!--            </template>-->
        <!--            <template slot="end">-->
        <!--              <span class="rangeMax">-->
        <!--                {{ constants.ranges.backlight.max }}-->
        <!--              </span>-->
        <!--            </template>-->
        <!--          </range-input>-->
        <!--        </div>-->
      </div>
    </div>

    <br /><br />

    <div v-if="device.data.type === constants.deviceTypes.therm">
      <h4 class="subtitle">{{ $t("settings.therm") }}</h4>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-switch v-model="form.windows_open_mode" type="is-success">
              {{ $t("settings.openWindows") }}
            </b-switch>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <b-switch v-model="form.use_floor_probe" type="is-success">
              {{ $t("settings.useFloorProbe") }}
            </b-switch>
          </div>
        </div>
      </div>
      <br /><br />
    </div>

    <div
      v-if="
        device.data.type === constants.deviceTypes.radiator ||
        device.data.type === constants.deviceTypes.radiatorb
      "
    >
      <h4 class="subtitle">{{ $t("settings.radiator") }}</h4>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-switch v-model="form.windows_open_mode" type="is-success">
              {{ $t("settings.openWindows") }}
            </b-switch>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <b-switch v-model="form.presence_mode" type="is-success"
              >{{ $t("settings.presence") }}
            </b-switch>
          </div>
        </div>
      </div>
      <br /><br />
    </div>

    <div
      v-if="
        device.data.type === constants.deviceTypes.towel ||
        device.data.type === constants.deviceTypes.oval_towel
      "
    >
      <h4 class="subtitle">{{ $t("settings.towel") }}</h4>
      <div class="columns">
        <div class="column">
          <div class="field">
            <b-switch v-model="form.windows_open_mode" type="is-success">
              {{ $t("settings.openWindows") }}
            </b-switch>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <b-switch v-model="form.two_hours" type="is-success">
              {{ $t("settings.twoHours") }}
            </b-switch>
          </div>
        </div>
      </div>
      <br /><br />
    </div>

    <div
      v-if="
        device.data.type === constants.deviceTypes.therm ||
        device.data.type === constants.deviceTypes.radiatorb ||
        device.data.type === constants.deviceTypes.oval_towel
      "
    >
      <h4 class="subtitle">{{ $t("settings.preconfig") }}</h4>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label>{{ $t("settings.preconfigTitle") }}</label>
            <br />

            <div class="select" style="width: 100%">
              <select style="width: 100%" v-model.number="form.pre_config">
                <option
                  :value="
                    device.data.type === constants.deviceTypes.therm ? 4 : 0
                  "
                >
                  {{ $t("settings.preconfigOff") }}
                </option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option
                  v-if="device.data.type !== constants.deviceTypes.therm"
                  value="4"
                >
                  4
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <br /><br />
    </div>

    <div v-if="device.data.type === constants.zoneTypes.acs">
      <h4 class="subtitle">{{ $t("settings.acs") }}</h4>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label>{{ $t("settings.antiLegionella") }} </label>
            <br />

            <div class="select" style="width: 100%">
              <select style="width: 100%" v-model.number="form.legionella_conf">
                <option value="0">0</option>
                <option value="7">7</option>
                <option value="14">14</option>
                <option value="30">30</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br /><br />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import constants from "@/config/constants";
import RangeInput from "@/components/shared/RangeInput.vue";

export default {
  name: "device-advanced-settings",
  components: {
    RangeInput,
  },
  data() {
    return {
      constants: constants,
      form: {},
    };
  },
  computed: {
    canEnterUserMode: function () {
      let requiredFields = [
        "um_password",
        "um_max_temp",
        "um_min_temp",
        "user_mode",
      ];

      let canEnter = true;

      requiredFields.forEach((field) => {
        if (this.device.data[field] === undefined) canEnter = false;
      });

      return canEnter;
    },

    ...mapState("installations", {
      installation: "current",
    }),

    ...mapState("zones", {
      zone: "current",
    }),

    ...mapState("devices", {
      device: "current",
    }),

    ranges: function () {
      return {
        eco: {
          min: this.device.data.user_mode
            ? this.device.data.um_min_temp
            : this.device.data.type === constants.deviceTypes.acs
            ? constants.ranges.eco.acs.min
            : constants.ranges.eco.radiator.min,
          max:
            this.device.data.type === constants.deviceTypes.acs
              ? constants.ranges.eco.acs.max
              : constants.ranges.eco.radiator.max,
        },

        comfort: {
          min:
            this.device.data.type === constants.deviceTypes.acs
              ? constants.ranges.comfort.acs.min
              : constants.ranges.comfort.radiator.min,
          max: this.device.data.user_mode
            ? this.device.data.um_max_temp
            : this.device.data.type === constants.deviceTypes.acs
            ? constants.ranges.comfort.acs.max
            : constants.ranges.comfort.radiator.max,
        },
        legionella_conf: {
          min: constants.ranges.legionella_conf.min,
          max: constants.ranges.legionella_conf.max,
        },
        offset_probe: {
          min: constants.ranges.offset_probe.min,
          max: constants.ranges.offset_probe.max,
        },
      };
    },
  },
  methods: {
    goBack: function () {
      this.$router.push(
        "/installations/" +
          this.installation[".key"] +
          "/zone/" +
          this.zone.path.split("/")[this.zone.path.split("/").length - 1] +
          "/device/" +
          this.device.serialnumber
      );
    },

    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
    }),

    ...mapActions("devices", {
      setAdvancedSettings: "setAdvancedSettings",
      setDevice: "setCurrent",
      setLegionellaConfig: "setLegionellaConfig",
      setDeviceTemperature: "setTemperature",
    }),

    save: function () {
      this.setAdvancedSettings({
        device: this.device,
        form: this.form,
        inherit: false,
      });
      this.goBack();
    },
    setBalancedMode: function () {
      let temp = 19;
      if (this.device.data.type === constants.deviceTypes.acs) temp = 55;

      this.setDeviceTemperature({ device: this.device, temperature: temp });
      this.$dialog.alert({
        message: this.$t("settings.balancedModeSetted"),
        type: "is-success",
      });
    },

    fillForm: function () {
      //COMMON FIELDS
      let form = {
        hilo_pilot: this.device.data.pilot_mode,
        eco: this.device.data.eco,
        comfort: this.device.data.comfort,
        adelanto_enable: this.device.data.adelanto_enable,
        backlight: this.device.data.backlight,
        backlight_on: this.device.data.backlight_on,
        ice_mode: this.device.data.ice_mode,
        use_floor_probe: this.device.data.use_floor_probe,
        block_local: this.device.data.block_local,
        block_remote: this.device.data.block_remote,
        hotel_mode:
          constants.deviceTypes.oval_towel === this.device.data.type
            ? false
            : this.device.data.block_remote && this.device.data.user_mode,
        pre_config: this.device.data.schedule_type
          ? this.device.data.schedule_type
          : constants.ownScheduleValue,
      };

      //TYPE CASES
      switch (this.device.data.type) {
        case constants.deviceTypes.acs:
          form.legionella_conf =
            typeof this.device.data.legionella_conf === "undefined"
              ? constants.ranges.legionella_conf.min
              : this.device.data.legionella_conf;
          break;
        case constants.deviceTypes.radiator:
          form.use_floor_probe =
            typeof this.device.data.use_floor_probe === "undefined"
              ? false
              : this.device.data.use_floor_probe;
          form.windows_open_mode =
            typeof this.device.data.windows_open_mode === "undefined"
              ? false
              : this.device.data.windows_open_mode;
          form.presence_mode =
            typeof this.device.data.pir_mode === "undefined"
              ? false
              : this.device.data.pir_mode;
          break;
        case constants.deviceTypes.radiatorb:
          form.use_floor_probe =
            typeof this.device.data.use_floor_probe === "undefined"
              ? false
              : this.device.data.use_floor_probe;
          form.windows_open_mode =
            typeof this.device.data.windows_open_mode === "undefined"
              ? false
              : this.device.data.windows_open_mode;
          form.presence_mode =
            typeof this.device.data.pir_mode === "undefined"
              ? false
              : this.device.data.pir_mode;
          break;
        case constants.deviceTypes.towel:
          form.two_hours =
            typeof this.device.data.two_hours === "undefined"
              ? false
              : this.device.data.two_hours;
          break;
        case constants.deviceTypes.oval_towel:
          form.two_hours =
            typeof this.device.data.two_hours === "undefined"
              ? false
              : this.device.data.two_hours;
          form.offset_probe =
            typeof this.device.data.offset_probe === "undefined"
              ? false
              : this.device.data.offset_probe;
          form.windows_open_mode =
            typeof this.device.data.windows_open_mode === "undefined"
              ? false
              : this.device.data.windows_open_mode;
          form.presence_mode =
            typeof this.device.data.pir_mode === "undefined"
              ? false
              : this.device.data.pir_mode;
          form.buzzer =
            typeof this.device.data.buzzer === "undefined"
              ? false
              : this.device.data.buzzer;
          break;

        case constants.deviceTypes.therm:
          form.use_floor_probe =
            typeof this.device.data.use_floor_probe === "undefined"
              ? false
              : this.device.data.use_floor_probe;
          form.windows_open_mode =
            typeof this.device.data.windows_open_mode === "undefined"
              ? false
              : this.device.data.windows_open_mode;
          break;
      }

      this.form = form;
    },
  },

  mounted() {
    this.setInstallation(this.$route.params.id)
      .then(() => {
        this.setZone(this.$route.params.idZone).then(() =>
          this.setDevice(this.$route.params.idDevice).then(() => {
            this.fillForm();
          })
        );
      })
      .catch(() => {
        this.$router.push("/installations");
      });
  },
  watch: {
    "form.block_remote"(newValue) {
      if (newValue === false) {
        this.form.hotel_mode = false;
      }
    },
    "form.hotel_mode"(newValue) {
      if (newValue === true) {
        this.form.block_remote = true;
      }
    },
    device: function () {
      this.fillForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}

.advancedSettings {
  padding: 0 2rem 2rem;
}

h1.title {
  margin: 3rem 0 5rem;
}

.rangeMax {
  margin-left: 5%;
}

.rangeMin {
  margin-right: 5%;
}
</style>
